import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  url = "/assets/version.json";

  constructor(private http: HttpClient) { }

  get(): Observable<any> {
    return this.http.get<any>(this.url);
  }
}
